module.exports = __webpack_public_path__ + "img/card-image.ccd302d3.png";